
import { makeStyles } from "@material-ui/core/styles";
import { Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	DialogActions,
	Button,
	Chip
} from "@material-ui/core";
import ButtonWithSpinner from "../ButtonWithSpinner";
import React, { useEffect, useState } from 'react';
import toastError from '../../errors/toastError';
import api from '../../services/api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		padding: theme.spacing(2),
	},
}));

export const SaleFunnelModal = ({ nameFunnel, modalOpen, modalClose, modalId }) => {

	const [newSaleFunnel, setnewSaleFunnel] = useState("");
	const classes = useStyles();
	const [users, setUsers] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);

	useEffect(() => {
		if (nameFunnel && nameFunnel !== "") {
			setnewSaleFunnel(nameFunnel.trim());
		}
	},[nameFunnel])

	useEffect(() => {
		async function fetchData() {
			try {
				const { data } = await api.get("/users/");
				setUsers(data.users);
			} catch (err) {
				toastError(err);
			}
		}
		fetchData();
	}, []);

	const handleClick = async () => {
		try {
			if (modalId > 0) {
				if (!newSaleFunnel || newSaleFunnel.trim() === "") {
					toastError("O nome do funil de vendas é obrigatório.");
					return;
				}
				if (newSaleFunnel.trim() !== nameFunnel) {
					await api.put(`/sales-funnel/${modalId}`, {
						name: newSaleFunnel
					})
				}
					await api.put(`/sales-funnel/${modalId}/users/bulk-update`, {
						userIds: selectedUsers.map(user => user.id)
					});
			} else {
				await api.post("/sales-funnel", {
					name: newSaleFunnel
				})
				if (selectedUsers.length > 0) {
					const { data } = await api.get("/sales-funnel", {
						params: {
							name: newSaleFunnel
						}
					});
					const createdFunnel = data[0];

					await api.put(`/sales-funnel/${createdFunnel.id}/users/bulk-update`, {
						userIds: selectedUsers.map(user => user.id)
					});
				}
			}
			modalClose(newSaleFunnel);
		} catch (err) {
			toastError(err);
		}
	}

	useEffect(() => {
		(async () => {
			try {
				if (!modalId || modalId <= 0) {
					return;
				}
				const { data } = await api.get("/sales-funnel/user",{
					params: {
						salesFunnelId: modalId
					}
				});
				setSelectedUsers(data.map(item => item.user));
			} catch (error) {
				console.log(error);
				toastError(error);
			}
		})();
	}, [modalId]);

	return (
		<div className={classes.root}>
		<Dialog
			open={modalOpen}
			onClose={modalClose}
			maxWidth="xs"
			fullWidth
			disablePortal={false}
		>
			<DialogTitle>Funil de vendas</DialogTitle>

			<DialogContent>
					<TextField
						label="Nome funil"
						defaultValue={nameFunnel ?? ""}
						variant="outlined"
						fullWidth
						margin="dense"
						onChange={(e) => setnewSaleFunnel(e.target.value.trim())}
					/>

				</DialogContent>
				<DialogContent>
					<Autocomplete
						label="Usuarios"
						options={users}
						value={null}
						onChange={(e, value) => {
							setSelectedUsers((prev) => [...prev, value]);
						}}
						getOptionLabel={(option) => option.name}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								label="Usários"
								className="w-full"
							/>
						)}
						renderOption={(option) => (
							<div className="flex items-center justify-between w-full">
								<span>{option.name}</span>
							</div>
						)}
						filterOptions={(options) =>
							options.filter(
								(user) => !selectedUsers.some((s) => s.id === user.id)
							)
						}
					/>
				</DialogContent>
				<DialogContent>
					{selectedUsers.map((user) => (
						<Chip
							key={user.id}
							size="small"
							clickable
							label={user.name}
							onClick={() => {
							}}
							style={{
								backgroundColor: user.color || "#8e8e8e",
								color: "#fff",
								fontWeight: 500,
								cursor: "pointer",
								padding: "5px"
							}}
							onDelete={() => {
								setSelectedUsers((prev) => prev.filter((u) => u.id !== user.id));
							}}
							deleteIcon={<CloseIcon />}
						/>
					))}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={modalClose}
						color="secondary"
					variant="outlined"
				>
					Cancelar
				</Button>
				<ButtonWithSpinner
					variant="contained"
					type="button"
					onClick={() =>handleClick()}
					color="primary"
					disabled={!newSaleFunnel}
				>
					Gravar
				</ButtonWithSpinner>
			</DialogActions>
		</Dialog>
		</div>
	);
};
